export const ALPHANUMERIC_REGEX = /^[-\w.\s\u00C0-\u024F]+$/
export const ALPHANUMERIC_EMPTY_REGEX = /^[-\w.\s\u00C0-\u024F]*$/
export const METADATA_REGEX = /^[-\w.\s\u00C0-\u024F@]+$/
